module.exports = __webpack_public_path__ + "img/Home.66f74aab.svg";